import { useEffect, useState } from "react";

import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import ThirdPartyProviderDetailsForm from "./ThirdPartyProviderDetailsForm";
import ModalButton from "../../../../components/common/form/ModalButton";
import IconButton from "../../../../components/common/form/IconButton";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import { useDeleteProviderByIdMutation, useGetThirdPartyProviderByIdQuery } from "../thirdPartyProvider";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ThirdPartyProviderDetailPage = () => {

  let { providerId } = useParams();

  const { data: providerData } = useGetThirdPartyProviderByIdQuery(providerId);
  const [deleteAutoHoa, { isLoading }] = useDeleteProviderByIdMutation();
  const navigate = useNavigate();

  const [crumbs, setCrumbs] = useState<any[]>([])
  useEffect(() => {

    setCrumbs([
      { content: "Home", url: "/home" },
      { content: "Third Party Provider", url: "/third-party-providers" },
      { content: "Update Third Party Provider", url: "" }
    ])

  }, []);
  const handleDelete = async () => {
    if (providerId) {
      try {
        await deleteAutoHoa(providerId).unwrap();
        navigate(AppRoutes.ThirdPartyProvider.path);
      } catch (error) {
        console.error("Failed to delete:", error);
      }
    }
  };
  return (
    <>
      <div className={"justify-between text-md sm:block md:flex lg:flex px-2 py-2"} >
        <Breadcrumb crumbs={crumbs} />
        <div className={"justify-between sm:block md:flex lg:flex"}>
          {providerId && hasPermission(["HOATPP-D"]) && (
            <ModalButton
              triggerButton={
                <IconButton icon={<FaTrash />}
                  title={"Auditable Info"} hasBackground={true} className="mr-2" />
              }
              modal={
                <ConfirmationModal
                  show={true}
                  setShow={() => { }}
                  title={"Delete Third Party Provider"}
                  bodyMessage={"Are you sure you want to delete this Third Party Provider?"}
                  onSubmit={handleDelete}
                  isLoading={isLoading}
                />
              }
            />
          )}
          {
            hasPermission(["AUDIT-V"]) &&
            <AuditableInfoButton obj={providerData} />}
        </div>
      </div>
      <div className="px-2 py-2">
        <ThirdPartyProviderDetailsForm />
      </div >
    </>
  );
};

export default ThirdPartyProviderDetailPage;